import "./LabAdminDetailsEditComponent.scss";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import {CommonService} from "../../../../../shared/services";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import Grid from "@mui/material/Grid";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import * as Yup from "yup";
import commonService from "../../../../../shared/services/common.service";
import FormikAutoCompleteDropdown
    from "../../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import LinkComponent from "../../../../../shared/components/link/LinkComponent";
import useRedirectUser from "../../../../../shared/hooks/useRedirectUser";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";

interface LabAdminDetailsEditComponentProps {
    labAdminDetails: any;
    labDetails: any;
    onEditCancel: any;
    onUpdateComplete: any;
}

const validationSchema = Yup.object({
    adminId: Yup.mixed().nullable()
    // .required('Admin is Required'),
});

interface LabAdminDetailsFormSchema {
    adminId: any,
}

const formInitialValues: LabAdminDetailsFormSchema = {
    adminId: "",
}
const LabAdminDetailsEditComponent = (props: LabAdminDetailsEditComponentProps) => {
    const {labDetails, onUpdateComplete, onEditCancel} = props;
    const {handleRedirectUserModule} = useRedirectUser();
    const [adminDetailsFormInitialValues, setAdminDetailsFormInitialValues] = useState<LabAdminDetailsFormSchema>(formInitialValues)
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const [labAdminsList, setLabAdminsList] = useState<any>([]);
    const [labAdminsListLoading, setLabAdminsListLoading] = useState<boolean>(false);
    const [labAdminListLoadingFailed, setLabAdminListLoadingFailed] = useState<boolean>(false);
    const [labAdminListLoaded, setLabAdminListLoaded] = useState<boolean>(false);


    const onFormSubmit = useCallback((values: any, {
        setSubmitting,
        setErrors,
    }: FormikHelpers<any>) => {
        const payload = {adminId: values?.adminId?.id || null};
        setSubmitting(true);
        CommonService._lab.editLabDetails(labDetails?.id, payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                // onUpdateComplete(response?.data?.adminDetails);
                onUpdateComplete({...labDetails, ...response.data})
            })
            .catch((error: any) => {
                setErrors(error?.errors);
                CommonService.handleErrors(setErrors, error);
                CommonService._alert.showToast('Error editing Admin details ', "success");
                setSubmitting(false);
            });
    }, [labDetails, onUpdateComplete]);

    useEffect(() => {
        if (labDetails?.adminDetails && Object.keys(labDetails?.adminDetails).length) {
            setAdminDetailsFormInitialValues({adminId: labDetails?.adminDetails});
        }
    }, [labDetails]);

    const redirectUser = useCallback(() => {
        handleRedirectUserModule({type: 'labAdmin'})
    }, [handleRedirectUserModule])

    const getLabAdminsList = useCallback(() => {
        setLabAdminsListLoading(true);
        setLabAdminListLoaded(false);
        setLabAdminListLoadingFailed(false)
        commonService._lab.getLabAdminsList({})
            .then((response: IAPIResponseType<any>) => {
                setLabAdminsList(response?.data);
                setLabAdminListLoaded(true);
                setLabAdminsListLoading(false);
            })
            .catch((error: any) => {
                setLabAdminListLoadingFailed(true);
                setLabAdminsListLoading(false);
            });
    }, [])

    useEffect(() => {
        getLabAdminsList();
    }, [getLabAdminsList]);

    return (
        <div className={'admin-details-edit-component details-tab-data-content'}>
            <Formik
                validationSchema={validationSchema}
                initialValues={adminDetailsFormInitialValues}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                innerRef={formikRef}
                onSubmit={onFormSubmit}
            >
                {({isSubmitting, resetForm, values, isValid, setFieldValue, validateForm, errors, dirty}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (
                        <Form noValidate={true} className={"lab-admin-details-add-holder"}>
                            <div className="t-form-controls-wrapper pdd-top-5">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'adminId'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Lab Admin'}
                                                        placeholder={'Select Lab Admin'}
                                                        isDataLoaded={labAdminListLoaded}
                                                        isDataLoading={labAdminsListLoading}
                                                        isDataLoadingFailed={labAdminListLoadingFailed}
                                                        // required={true}
                                                        formikField={field}
                                                        data={labAdminsList}
                                                        valueKey={'id'}
                                                        getOptionLabel={(option => commonService.getFullName(option) || '')}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <div className="redirect-new-link-wrapper">
                                            <div>Didn't find admin?</div>
                                            <LinkComponent className={"redirect-link"}
                                                           onClick={redirectUser}>Create Admin</LinkComponent>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FeedbackComponent className={"mrg-top-10 mrg-bottom-10"}>
                                            Adding an admin is recommended, but if unavailable, it can be skipped
                                            and added later.
                                        </FeedbackComponent>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className="form-action-section-edit">
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"secondary"}
                                    type={"button"}
                                    variant={"outlined"}
                                    disabled={isSubmitting}
                                    fullWidth={false}
                                    handleClick={() => {
                                        onEditCancel()
                                    }}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    type="submit"
                                    color={"primary"}
                                    className={"width-25"}
                                    variant={"contained"}
                                    fullWidth={false}
                                    disabled={!(isValid && dirty)}
                                    isLoading={isSubmitting}
                                >
                                    Save
                                </ButtonComponent>
                            </div>

                        </Form>
                    )
                }
                }
            </Formik>
        </div>
    );

};

export default LabAdminDetailsEditComponent;
